'use strict';
import React, { PureComponent } from 'react';


class GrupoRadioButton extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            activo,
            classLabel,
            estaHabilitado,
            label,
            nombre,
            onClick,
            seccion,
            valor
        } = this.props;

        return (
            <div className="Tarjetas-contenedorGrupoRadioButtonLabel" onClick={onClick ? () => onClick(seccion, nombre, valor) : null}>
                <div className="Tarjetas-contenedorRadioButton">
                    <div className="AsientosContables--overflowHidden">
                        <div className={"AsientosContables--floatLeft " + (activo ? "Tarjetas-outsideRadioButtonActivo" : "Tarjetas-outsideRadioButtonInactivo") + (estaHabilitado ? "" : " Tarjetas-outsideRadioButton--deshabilitado seccionDatosGenerales__contenedorRB--deshabilitado")}></div>
                        <div className={"AsientosContables--floatLeft " + (activo ? estaHabilitado ? "Tarjetas-insideRadioButton" : "Tarjetas-insideRadioButton Tarjetas-insideRadioButton--deshabilitado seccionDatosGenerales__contenedorRB--deshabilitado" : null)}></div>
                    </div>
                </div>
                
                <div className="Tarjetas-contenedorLabel">
                    <label className={"ABMModelosModalContainer__copiaRenglonlabel " + classLabel}>{label}</label>
                </div>
            </div>
        );
    }
}

export default GrupoRadioButton;